/* eslint-disable max-len */
/**
 * Spanish translations.
 */
export default {
  ACTION: {
    CANCEL: 'Cancelar',
    CONFIRM: 'Confirmar',
    SAVE: 'Guardar',
    SEARCH: 'Buscar'
  },
  ERROR: {},
  HEADER: {
    EMAIL: 'E-mail',
    END_DATE: 'Fecha de finalización',
    MEMBER_ID: 'Miembro ID',
    NAME: 'Nombre'
  },
  LABEL: {
    ALLOW_ADD_MEMBERS: 'Permite agregar miembros',
    CREATE_MEMBER: 'Agregar miembro',
    DELETE_MEMBER_MODAL_TITLE: 'Eliminar miembro',
    EDIT_MEMBER: 'Editar miembro',
    EMAIL: 'E-mail',
    END_DATE: 'Fecha de finalización',
    MEMBERS: 'Miembros',
    NAME: 'Nombre',
    NO: 'No',
    YES: 'Sí'
  },
  SENTENCE: {
    DELETE_MEMBER_TEXT: '¿Seguro que quieres eliminar este miembro?',
    NO_MEMBER_NAME_EMAIL: 'Ningún nombre y/o correo electrónico',
    NO_MEMBER_NAME_EMAIL_DETAIL: 'Indica el nombre y/o correo electrónico',
    NO_ROWS_MEMBERS: 'Sin miembros',
    NO_ROWS_MEMBERS_DESCRIPTION: 'Cambia los criterios de búsqueda'
  },
  SUCCESS: {
    MEMBER_DELETED: 'Miembro eliminado correctamente',
    MEMBER_DETAILS_SAVED: 'Miembro agregado correctamente',
    SUCCESS: 'Acción realizada correctamente'
  },
  TOOLTIP: {
    EDIT_MEMBER: 'Editar miembro',
    EMAIL: 'E-mail',
    END_DATE: 'Fecha de finalización',
    MEMBER_ID: 'Miembro ID',
    NAME: 'Nombre',
    REMOVE_MEMBER: 'Eliminar miembro'
  }
};
